import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import dayjs from "dayjs";
import { useState } from "react";

// @deprecated. Use month component below
export default function DateComponent({
  onChange,
}: {
  onChange: (date: dayjs.Dayjs) => void;
}) {
  const [currDate, setCurrDate] = useState<dayjs.Dayjs>(dayjs());

  const handleLeft = () => {
    const _date = dayjs(currDate).subtract(1, "M");
    setCurrDate(_date);
    onChange(_date);
  };

  const handleRight = () => {
    const _date = dayjs(currDate).add(1, "M");
    setCurrDate(_date);
    onChange(_date);
  };

  return (
    <div className="flex gap-2">
      <Button
        onClick={handleLeft}
        id="date-left"
        type="text"
        icon={<CaretLeftOutlined style={{ color: "#7f1bd0" }} />}
      ></Button>

      <div className="flex justify-center align-items mt-1">
        {dayjs(currDate).format("MMM YYYY")}
      </div>

      <Button
        type="text"
        onClick={handleRight}
        id="date-left"
        icon={<CaretRightOutlined style={{ color: "#7f1bd0" }} />}
      ></Button>
    </div>
  );
}

export function MonthComponent({
  onChange,
}: {
  onChange: (startDate: string, endDate: string) => void;
}) {
  const [currDate, setCurrDate] = useState<dayjs.Dayjs>(dayjs());

  const handleLeft = () => {
    const _date = dayjs(currDate).subtract(1, "M");
    setCurrDate(_date);
    onChange(
      dayjs(_date).startOf("M").format("YYYY-MM-DD"),
      dayjs(_date).endOf("M").format("YYYY-MM-DD"),
    );
  };

  const handleRight = () => {
    const _date = dayjs(currDate).add(1, "M");
    setCurrDate(_date);
    onChange(
      dayjs(_date).startOf("M").format("YYYY-MM-DD"),
      dayjs(_date).endOf("M").format("YYYY-MM-DD"),
    );
  };

  return (
    <div className="flex gap-2">
      <Button
        onClick={handleLeft}
        id="date-left"
        type="text"
        icon={<CaretLeftOutlined style={{ color: "#7f1bd0" }} />}
      ></Button>

      <div className="flex justify-center align-items mt-1">
        {dayjs(currDate).format("MMM YYYY")}
      </div>

      <Button
        type="text"
        onClick={handleRight}
        id="date-left"
        icon={<CaretRightOutlined style={{ color: "#7f1bd0" }} />}
      ></Button>
    </div>
  );
}
